export default "__VITE_ASSET__C5y1W84B__"